import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import StackMapActions from 'app/actions/StackMapActions';
import StackMapLink from './StackMapLink';

export class StackMapLinkContainer extends React.PureComponent {
  render() {
    return <StackMapLink {...this.props} />;
  }
}

StackMapLinkContainer.propTypes = {
  bibItem: ImmutablePropTypes.map.isRequired,
  currentLibrary: libraryShape.isRequired,
  stackMapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleClick: PropTypes.func
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state)
});

const mapDispatchToProps = dispatch => ({
  stackMapActions: bindActionCreators(StackMapActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(StackMapLinkContainer);
